import { GetSkinsRes } from '@zeusm/business/core/entities';

import { getCardSkinsMock, getWalletSkinsCollectionMock } from './dictionaries.mock';

export const mockGetSkinsRes: GetSkinsRes = {
  cardSkins: getCardSkinsMock(2),
  walletSkins: getWalletSkinsCollectionMock(),
};
